<div class="table-row">
  <div class="d-flex">
    <div class="text text-separator">
      <div *ngIf="label" class="table-row-label" [style.width.%]="labelWidth()">{{label | translate}}</div>
      <ng-content select="[label]"></ng-content>
      <div *ngIf="_showWarning || _icon?.length" class="icon-area">
        <span *ngIf="_showWarning" class="icon" [ngbTooltip]="toolTipWarning" [placement]="placement">
          <qpoint-icon class="warning" icon="exclamation-triangle" iconType="solid"></qpoint-icon>
        </span>
        <span *ngIf="_icon?.length" class="icon" [ngbTooltip]="toolTip" [placement]="placement" [tooltipClass]="tooltipClass">
          <qpoint-icon [icon]="_icon" [iconType]="iconType" [style.color]="iconColor" (mouseenter)="emitIconMouseEvent($event)" (click)="emitIconMouseClickEvent($event)"></qpoint-icon>
        </span>
      </div>
    </div>

    <div class="text main">
      <div class="d-flex flex-column">
        <ng-content select="[flexTableMain]"></ng-content>
      </div>
    </div>
  </div>
  <div class="actions">
    <div>
      <ng-content select="[flexTableActions]"></ng-content>
    </div>
  </div>
</div>
